import { Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import { HelmetProvider } from "react-helmet-async";
import NavBar from './navbar/navbar';
import HomePage from './home/home';
import Contact from './kontakt/kontakt';
import Porady from './shop/shop';
import FooterBar from './footer/footer';
import ScrollToTop from './scroll/scroll-top';
import CookieConsent from './cookies/CookieConsent';
import PozostaleUslugi from './other/otherJob'
import NavBarBurger from './burger/burber';
import Rodo from './rodo/rodo';
import AboutMe from './about/about';
import WinterStorage from './other/other_list/winter-storage';
import Servise from './servise/servise';
import MotorcycleList from './shop/shop';
import ProductDetails from './shop/product-details';
import ServicesPage from './ServicesPrice/services-price';
import TransportMoto from './other/other_list/transport';
import ServiseAtv from './servise/servise_list/servise_atv';
import ServiseSkuter from './servise/servise_list/servise_skuter';
import ServiseMoto from './servise/servise_list/servise_moto';
import ServiseTechnical from './servise/servise_list/servise_technical';
import MotorcyclePurchase from './other/other_list/motorcycle_purchase';
import MotorcycleConsulting from './other/other_list/consulting';
import './App.css';

function App() {
  const [host] = useState("https://vh13875.vh.net.pl/django");

  return (
    <HelmetProvider>
      <CookieConsent />
      <ScrollToTop />
      <NavBarBurger/>
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage host={host}/>} /> 
        <Route path="/kontakt" element={<Contact />} /> 
        <Route path="/porady" element={<Porady host={host}/>} /> 
        <Route path="/pozostale_uslugi" element={<PozostaleUslugi />} />
        <Route path="/polityka-prywatności" element={<Rodo />} />
        <Route path="/o-firmie" element={<AboutMe/>} />
        <Route path="/zimowanie" element={<WinterStorage/>} />
        <Route path="/serwis" element={<Servise/>} />
        <Route path="/motocykle" element={<MotorcycleList host={host} />} />
        <Route path="/motocykle/:id" element={<ProductDetails host={host}  />} />
        <Route path="/cennik" element={<ServicesPage host={host} />} />
        <Route path="/transport-motocykli" element={<TransportMoto />} />
        <Route path="/serwis-quadow" element={<ServiseAtv/>} />
        <Route path="/serwis-skuterow" element={<ServiseSkuter/>} />
        <Route path="/serwis-motocykli" element={<ServiseMoto/>} />
        <Route path="/przeglady-techniczne" element={<ServiseTechnical/>} />
        <Route path="/skup" element={<MotorcyclePurchase/>} />
        <Route path="/doradztwo" element={<MotorcycleConsulting/>} />
        
      </Routes>
      <FooterBar/>
    </HelmetProvider>
  );
}

export default App;

